(function () {
  var MOBILE_MAX_WIDTH = 749;

  function isMobileViewport() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX_WIDTH + 'px)').matches;
  }

  function markPlaying(root) {
    root.classList.add('is-video-playing');
  }

  function getDesktopVideo(root) {
    return (
      root.querySelector('[data-banner-video="desktop"]') ||
      root.querySelector('.melbourne-marathon-2026-banner__video.hide-mb')
    );
  }

  function getMobileVideo(root) {
    return (
      root.querySelector('[data-banner-video="mobile"]') ||
      root.querySelector('.melbourne-marathon-2026-banner__video.hide-pc')
    );
  }

  function getActiveVideo(root) {
    var mobileVideo = getMobileVideo(root);
    var desktopVideo = getDesktopVideo(root);

    if (isMobileViewport()) {
      return mobileVideo || desktopVideo;
    }

    return desktopVideo || mobileVideo;
  }

  function getInactiveVideo(root, activeVideo) {
    var mobileVideo = getMobileVideo(root);
    var desktopVideo = getDesktopVideo(root);

    if (activeVideo === desktopVideo) {
      return mobileVideo;
    }

    return desktopVideo;
  }

  function getVideoSourceEl(video) {
    return video ? video.querySelector('source') : null;
  }

  function getVideoSrc(video) {
    if (!video) return '';
    var source = getVideoSourceEl(video);
    return video.getAttribute('src') || (source && source.getAttribute('src')) || '';
  }

  function restoreVideoSource(video) {
    if (!video || video.dataset.bannerSrc) return;
    video.dataset.bannerSrc = getVideoSrc(video);
  }

  function unloadVideo(video) {
    if (!video) return;

    video.pause();
    video.preload = 'none';

    var source = getVideoSourceEl(video);
    if (video.getAttribute('src')) {
      video.removeAttribute('src');
      video.load();
      return;
    }

    if (source && source.getAttribute('src')) {
      source.removeAttribute('src');
      video.load();
    }
  }

  function loadVideo(video) {
    if (!video || !video.dataset.bannerSrc) return;

    video.preload = 'auto';

    var source = getVideoSourceEl(video);
    if (source) {
      if (!source.getAttribute('src')) {
        source.setAttribute('src', video.dataset.bannerSrc);
      }
    } else if (!video.getAttribute('src')) {
      video.setAttribute('src', video.dataset.bannerSrc);
    }

    if (video.readyState === 0) {
      video.load();
    }
  }

  function playVideo(video) {
    if (!video) return;

    video.muted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function activateVideo(root, activeVideo, inactiveVideo) {
    root.querySelectorAll('.melbourne-marathon-2026-banner__video').forEach(function (video) {
      restoreVideoSource(video);
      video.classList.remove('is-active');
    });

    if (inactiveVideo) {
      unloadVideo(inactiveVideo);
    }

    if (!activeVideo) return;

    activeVideo.classList.add('is-active');
    loadVideo(activeVideo);

    activeVideo.addEventListener(
      'playing',
      function () {
        markPlaying(root);
      },
      { once: true }
    );

    if (!activeVideo.paused && activeVideo.readyState >= 2) {
      markPlaying(root);
    }

    playVideo(activeVideo);
  }

  function initBannerVideo(root) {
    if (!root.querySelector('.melbourne-marathon-2026-banner__video')) return;

    root.querySelectorAll('.melbourne-marathon-2026-banner__video').forEach(restoreVideoSource);
    var initialActiveVideo = getActiveVideo(root);
    activateVideo(root, initialActiveVideo, getInactiveVideo(root, initialActiveVideo));

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        var activeVideo = getActiveVideo(root);
        activateVideo(root, activeVideo, getInactiveVideo(root, activeVideo));
      }, 200);
    });
  }

  function initWhiteHeader(root) {
    if (root.getAttribute('data-white-header') !== 'true') return;

    document.body.classList.add('header-no-fixed');

    var header = document.querySelector('.header-wrapper') || document.querySelector('.site-header');
    if (header) {
      header.classList.add('white-header');
    }
  }

  function initBannerScroll(root) {
    var button = root.querySelector('.melbourne-marathon-2026-banner__button');
    if (!button) return;

    button.addEventListener('click', function (event) {
      var href = button.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;

      var target = document.querySelector(href);
      if (!target) return;

      event.preventDefault();

      var siteHeader = document.querySelector('.site-header') || document.querySelector('.header-wrapper');
      var headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
      var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      window.scrollTo({ top: targetPosition, behavior: 'smooth', block: 'center' });
    });
  }

  function initBanner(root) {
    if (!root || root.dataset.bannerInit === 'true') return;
    root.dataset.bannerInit = 'true';

    initWhiteHeader(root);
    initBannerVideo(root);
    initBannerScroll(root);
  }

  function boot() {
    document.querySelectorAll('melbourne-marathon-2026-banner').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('melbourne-marathon-2026-banner');
    if (root) initBanner(root);
  });

  if (!customElements.get('melbourne-marathon-2026-banner')) {
    customElements.define(
      'melbourne-marathon-2026-banner',
      class MelbourneMarathon2026Banner extends HTMLElement {}
    );
  }
})();
